<header class="di-app-header">
  <div class="container-xxl">
    <div class="row align-items-center">
      <div class="col" *ngIf="innerWidth < 993">
        <button class="toggleMobileMenu" (click)="showMobileMenu = true">
          <span class="material-symbols-outlined">menu</span>
        </button>
      </div>

      <div class="col-6 col-lg-10">
        <div class="di-logo-nav-wrapper">
          <a class="di-logo" routerLink="/"><img src="assets/images/datium-logo.svg" alt="Datium Insights" width="110"
              height="39" fetchpriority="high" /></a>

          <products-dropdown [viewFrom]="'desktop'" *ngIf="innerWidth >= 992"></products-dropdown>

          <app-menu *ngIf="innerWidth >= 992"></app-menu>
        </div>
        <!-- .di-logo-nav-wrapper ends here -->
      </div>

      <div class="col">
        <div class="di-product-user-dropdown">
          <app-profile></app-profile>
        </div>
        <!-- .di-product-user-dropdown ends here -->
      </div>
    </div>
  </div>
</header>

<mobile-menu [ngClass]="{ 'menu-opened': innerWidth < 992 && showMobileMenu }" [userName]="userName"
  [showMobileMenu]="showMobileMenu" [userEmail]="userEmail" (menuStatus)="chkStatus($event)"></mobile-menu>